"use client";
import { useEffect } from "react";
import { slugActual } from "@/lib/ruta";

export default function AcentoGlobal() {
  useEffect(() => {
    const slug = slugActual();
    const clave = `acento:${slug || "_"}`;
    const aplicar = (c?: string | null) => { if (c) document.documentElement.style.setProperty("--acento", c); };
    try { aplicar(localStorage.getItem(clave)); } catch {}
    fetch(slug ? `/api/config?e=${slug}` : "/api/config").then((r) => r.json()).then((d) => {
      const c = (d?.config ?? d)?.color_acento;
      aplicar(c);
      try { if (c) localStorage.setItem(clave, c); } catch {}
    }).catch(() => {});
  }, []);
  return null;
}
